import { createFileRoute } from '@tanstack/react-router';
import { LibraryPage } from '@/components/library/LibraryPage.tsx';
import {
  libraryTagFilter,
  parseLibraryKind,
  parseLibraryTag,
  type LibrarySearch,
} from '@/components/library/libraryViews';

export const Route = createFileRoute('/$spaceSlug/library')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): LibrarySearch => ({
    kind: parseLibraryKind(search.kind),
    tag: parseLibraryTag(search.tag),
  }),
  head: () => ({
    meta: [
      {
        title: 'Findya | Library',
      },
    ],
  }),
});

function RouteComponent() {
  const { kind, tag } = Route.useSearch();

  return (
    <div className="flex grow overflow-hidden mx-auto max-w-[900px] w-full">
      <LibraryPage kind={kind} tagId={libraryTagFilter({ tag })} />
    </div>
  );
}
